import { Text } from '../Text'
import { Column, Row } from '../Grid'
import { NextImage } from '../NextImage'

const PatientType = ({ psycho }) => {
  return (
    <Column maxWidth='160px' width='100%'>
      <Text
        color='primary'
        textAlign='left'
        fontSize={['1rem', '1rem', '1.5rem']}
        fontWeight='400'
        pl={['0px', '0px', '24px']}
        lineHeight='24px'
      >
        atende
      </Text>
      {psycho?.patient_kids && (
        <Row width='100%' mt='4px'>
          <NextImage height={16} width={16} src='/static/images/baby.svg' alt='Crianças' />
          <Text ml='12px' color='lightGray' fontSize={['0.75rem', '0.75rem', '1rem']}>
            crianças
          </Text>
        </Row>
      )}
      {psycho?.patient_adolescent && (
        <Row mt='4px'>
          <NextImage height={16} width={16} src='/static/images/girl.svg' alt='' />
          <Text ml='12px' color='lightGray' fontSize={['0.75rem', '0.75rem', '1rem']}>
            adolescentes
          </Text>
        </Row>
      )}
      {psycho?.patient_adult && (
        <Row mt='4px'>
          <NextImage height={16} width={16} src='/static/images/woman.svg' alt='' />
          <Text ml='12px' color='lightGray' fontSize={['0.75rem', '0.75rem', '1rem']}>
            adultos
          </Text>
        </Row>
      )}
      {psycho?.patient_couple && (
        <Row mt='4px'>
          <NextImage height={16} width={16} src='/static/images/parents.svg' alt='' />
          <Text ml='12px' color='lightGray' fontSize={['0.75rem', '0.75rem', '1rem']}>
            casais
          </Text>
        </Row>
      )}
      {psycho?.patient_elderly && (
        <Row mt='4px'>
          <NextImage height={15} width={15} src='/static/images/grandfather.svg' alt='' />
          <Text ml='12px' color='lightGray' fontSize={['0.75rem', '0.75rem', '1rem']}>
            idosos
          </Text>
        </Row>
      )}
    </Column>
  )
}

export default PatientType
